import { render } from "./OverlayDoorParams.vue?vue&type=template&id=6f4301f0&scoped=true"
import script from "./OverlayDoorParams.vue?vue&type=script&lang=js"
export * from "./OverlayDoorParams.vue?vue&type=script&lang=js"

import "./OverlayDoorParams.vue?vue&type=style&index=0&id=6f4301f0&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4301f0"]])

export default __exports__